import React from 'react';
import { OptionStyle } from './style';

export default function ActiveAndEmail({ validate, option, modifyFunction, labelText }) {
  return (
    <OptionStyle thisIs={option}>
      <p>{labelText}</p>
      {validate ? (
        <button onClick={() => modifyFunction(!option)}>{option ? 'Sim' : 'Não'}</button>
      ) : (
        <button>{option ? 'Sim' : 'Não'}</button>
      )}
    </OptionStyle>
  );
}
